import React from 'react';
import classes from '../Form.module.scss';

export default function FormInputText(props) {
  return (
    <>
      <input
        {...props.register}
        className={classes.input}
        type='text'
        placeholder={props.placeholder}
        data-has-error={props.errors ? 'true' : 'false'}
        disabled={props.isDisabled}
      />
      <label className={classes.inputLabel}>{props.label}</label>
      <div className={props.isDisabled ? classes.disabled : classes.inputError}>{props.errors && props.errorLabel}</div>
    </>
  );
}
